import { render, staticRenderFns } from "./SkeletonDefault.vue?vue&type=template&id=6b8bac84&functional=true"
import script from "./SkeletonDefault.vue?vue&type=script&lang=js"
export * from "./SkeletonDefault.vue?vue&type=script&lang=js"
import style0 from "./SkeletonDefault.vue?vue&type=style&index=0&id=6b8bac84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports